module.exports = {"Listado de procesos batch":"Listado de procesos batch","Administración de procesos batch":"Administración de procesos batch","Ver proceso de batch":"Ver proceso de batch","Editar proceso de batch":"Editar proceso de batch","Nueva proceso de batch":"Nueva proceso de batch","Fecha Inicio":"Fecha Inicio","Fecha Finalización":"Fecha Finalización","Tipo":"Tipo","Descripción":"Descripción","Cantidad con error":"Cantidad con error","Cantidad exitoso":"Cantidad exitoso","Resultado":"Resultado","Estado":"Estado"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/procesos-batch/es.json
// module id = 1548
// module chunks = 0